import { apiClient } from "../services/NetworkService";

const soundex = (s: string): string => {
  const a = s.toLowerCase().split("");
  const f = a.shift() || "";
  let r = "";
  
  const codes: Record<string, string | number> = {
    a: "", e: "", i: "", o: "", u: "",
    b: 1, f: 1, p: 1, v: 1,
    c: 2, g: 2, j: 2, k: 2, q: 2, s: 2, x: 2, z: 2,
    d: 3, t: 3,
    l: 4,
    m: 5, n: 5,
    r: 6,
  };

  r =
    f +
    a
      .map((v) => {
        return codes[v] !== undefined ? codes[v] : "";
      })
      .filter((v, i, arr) => {
        return i === 0 ? v !== codes[f] : v !== arr[i - 1];
      })
      .join("");

  return (r + "000").slice(0, 4).toUpperCase();
};

const getSearchData = async (token?: string): Promise<any> => {
  const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
  const response = await apiClient.get(`/api/search/data`, config);
  return response.data;
};

export default { getSearchData, soundex };
